import Tag from "../Tag";
import { SectionProps } from "./types";

export default function Section({ title, tag, children }: SectionProps) {
    return (
        <div style={{ background: "var(--card)", border: "1px solid var(--border)", borderRadius: 14, overflow: "hidden" }}>
            <div style={{
                display: "flex", alignItems: "center", gap: 10, padding: "14px 20px",
                borderBottom: "1px solid var(--border)", background: "var(--section-header)",
            }}>
                <span style={{ fontSize: 14, fontWeight: 600, color: "var(--text)", flex: 1 }}>{title}</span>
                {tag && <Tag>{tag}</Tag>}
            </div>
            <div style={{ padding: 20, display: "flex", flexDirection: "column", gap: 18 }}>{children}</div>
        </div>
    );
}